import { render, staticRenderFns } from "./pros-cons-switch.vue?vue&type=template&id=5e420c6d"
import script from "./pros-cons-switch.vue?vue&type=script&lang=ts"
export * from "./pros-cons-switch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports